import React from "react";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import Header from "./Header";
import Footer from "./Footer";

const privacyData = [
  {
    title: "Information Collection",
    desc:
      "By asking for your name, email, and favourite subjects, we can shape the lessons to match your needs.",
  },
  {
    title: "Use of Data",
    desc:
      "We only use your data to give you notes, study guides, and exam-focused resources that fit your level.",
  },
  {
    title: "Secure Data Storage",
    desc:
      "We protect personal information using secure technologies to prevent unauthorized access or misuse.",
  },
  {
    title: "No Data Selling",
    desc:
      "We respect your privacy and never sell or share your personal data with advertisers.",
  },
  {
    title: "Cookies for a Better Experience",
    desc:
      "Cookies help improve site performance, remember preferences, and enhance browsing speed.",
  },
  {
    title: "Third-Party Content",
    desc:
      "External websites and widgets follow their own privacy policies, which users should review individually.",
  },
  {
    title: "Student Rights",
    desc:
      "You may request correction, deletion of your data, or withdraw consent at any time.",
  },
  {
    title: "Policy Updates",
    desc:
      "Any updates to this Privacy Policy will be published on our website immediately.",
  },
];

const PrivacyPolicy = () => {
  return (
    <>
      <Header />

      <Box
        sx={{
          minHeight: { xs: "10vh", md: "20vh" },
          background:
            "linear-gradient(135deg, #0D2A54 0%, #1A4B83 50%, #2B6BA5 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          px: 2,
        }}
      >
        <PrivacyTipIcon
          sx={{
            fontSize: { xs: 30, sm: 40, md: 40 },
            color: "white",
          }}
        />
        <Typography
          sx={{
            color: "white",
            fontWeight: 900,
            fontSize: { xs: 22, sm: 30, md: 40 },
            textShadow: "1px 4px 8px rgba(0,0,0,0.3)",
          }}
        >
          Privacy Policy
        </Typography>
      </Box>

      <Grid container justifyContent="center" sx={{ p: { xs: 2, md: 8 } }}>
        <Grid size={{ xs: 12, md: 10 }} sx={{ mb: 4, textAlign: "center" }}>

          <Typography sx={{ fontSize: { xs: 16, md: 18 }, color: "#333", mt: { xs: 0, md: -2 } }}>
            With GetMyRank, you’ll find concise notes, organised worksheets, and practice tests
            that match what you need to boost your performance.

          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 10 }}>
          {privacyData.map((item, index) => (
            <Accordion
              key={index}
              sx={{
                mb: 2,
                borderRadius: 3,
                boxShadow: 3,
                "&:before": { display: "none" },
                transition: "0.2s",
                "&:hover": { transform: "scale(1.01)" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ minHeight: 70 }}
              >
                <Typography fontWeight="bold">
                  {index + 1}. {item.title}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Typography sx={{ lineHeight: 1.6 }}>
                  {item.desc}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </Grid>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
